module.exports = __webpack_public_path__ + "static/media/file-invoice-dollar.9db9b420.svg";